import { beam, beamTestnet, Chain } from 'viem/chains';

export const chains = [beam, beamTestnet] as [Chain, ...Chain[]];
